// @flow

'no babel-plugin-flow-react-proptypes';

import fetchDataWithDefaults, { fetchJSON } from './fetchData';
import FetchError from './fetchError';
import type { Arguments } from './fetchData';

export type {
  Arguments,
};

export {
  fetchJSON,
  FetchError,
};

export default fetchDataWithDefaults;
